import { FC, PropsWithChildren } from 'react'
import { styled } from 'styled-components'

type EmptyModelStateProps = PropsWithChildren<{
  heading?: string
  subheading?: string
}>

const EmptyModelState: FC<EmptyModelStateProps> = ({
  heading,
  subheading,
  children,
}) => (
  <Container>
    {heading ? <h3>{heading}</h3> : null}
    {subheading ? <p>{subheading}</p> : null}
    {children}
  </Container>
)

export default EmptyModelState

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 8px 0;
  border: 1px dashed ${(p) => p.theme.border};
  border-radius: 6px;
  background: ${(p) => p.theme.background};
  padding: 24px;
  color: ${(p) => p.theme.text};

  h3 {
    margin: 0 0 6px;
    color: ${(p) => p.theme.disabled};
    font-size: 13px;
    font-weight: 600;
  }

  p {
    opacity: 0.8;
    margin: 0;
    font-size: 12px;
  }
`
